import $ from 'jquery';
import closeAllMenus from '../../core/INF-closeAllMenus';
import openModal from './openModal';
import hashChange from './hashChange';

const Modal = () => {
  $(document).on('click', '[data-open-modal]', openModal);

  hashChange();
  $(window).on('hashchange', hashChange);

  $(document).on('click', '[data-close-modal]', () => {
    const $modal = $('[data-modal].Modal--open');
    $(document).trigger('modalWillClose', $modal);

    closeAllMenus();
    
    $(document).trigger('modalDidClose', $modal);
    $(document).trigger('scroll');
  });

  $(window).on('breakpointChange', () => {
    if (!$('[data-state]').hasClass('State--modal-open')) {
      return;
    }
    
    // Refiring openModal will readjust positioning
    const $modal = $('[data-modal].Modal--open');
    openModal($modal);
  });
};

export {
  Modal,
};